import React from "react"
import { FormikProps } from "formik"
import MyDateDayMonthYearFormField from "@common-components/fields/MyDateDayMonthYearFormField"
import MyInputFormField from "@common-components/fields/MyInputFormField"
import MySelectFormField from "@common-components/fields/MySelectFormField"
import { CONST_PERSONNEL_NDF_DETAILS_CATEGORIES_OPTIONS_FOR_SELECT2, CONST_PERSONNEL_NDF_DETAILS_CATEGORIE_KM } from "@common-constants/*"

interface Props {
     helpers: FormikProps<any>
     validationSchema: any
     index: number
     namePrefix?: string
}

export const NdfGroupedBasicFields = ({ helpers, validationSchema, index, namePrefix = "childs" }: Props) => {
     const isKM = helpers.values[namePrefix][index].categorie === CONST_PERSONNEL_NDF_DETAILS_CATEGORIE_KM

     return (
          <>
               <MySelectFormField
                    formikProps={helpers}
                    validationSchema={validationSchema}
                    options={CONST_PERSONNEL_NDF_DETAILS_CATEGORIES_OPTIONS_FOR_SELECT2}
                    name={`${namePrefix}[${index}].categorie`}
                    isSearchable={false}
                    placeholder={"Sélectionnez la catégorie..."}
                    label={"Catégorie"}
                    classNameLabel="col-lg-4"
                    classNameField="col-lg-8"
               />

               {helpers.values[namePrefix][index].categorie && !isKM && (
                    <div>
                         <MyInputFormField
                              formikProps={helpers}
                              validationSchema={validationSchema}
                              name={`${namePrefix}[${index}].numeroTicket`}
                              placeholder={"Saisissez le numéro de la dépense"}
                              label={<div className="required">Numéro de la dépense</div>}
                              autoComplete={"off"}
                              inputMode={"numeric"}
                              classNameLabel="col-lg-4"
                              classNameField="col-lg-8"
                              classNameLayout="mb-4"
                         />

                         <MyDateDayMonthYearFormField
                              name={`${namePrefix}[${index}].date`}
                              formikProps={helpers}
                              validationSchema={validationSchema}
                              placeholder={"Date"}
                              label={<span className={"required"}>Date</span>}
                              classNameLabel={"col-lg-4"}
                              classNameField={"col-lg-8"}
                         />
                    </div>
               )}
          </>
     )
}
